/**
 * The API only accepts `+<country code><10 digits>`, but phone fields are free text and people type
 * "0801 234 5678", "234-801...", or paste spaces and brackets. Strip the formatting and put the
 * country code back on so a valid number isn't rejected over punctuation.
 */
const DEFAULT_COUNTRY_CODE = "234";

export const normalizePhoneNumber = (phoneNumber: string): string => {
  const digits = (phoneNumber || "").replace(/\D/g, "");

  if (!digits) return "";

  // Already carries a country code, either typed as "+234..." or pasted as "234...".
  if (phoneNumber.trim().startsWith("+") || digits.startsWith(DEFAULT_COUNTRY_CODE)) {
    return `+${digits}`;
  }

  // Local format: "0801 234 5678" — the leading 0 stands in for the country code.
  if (digits.startsWith("0")) {
    return `+${DEFAULT_COUNTRY_CODE}${digits.slice(1)}`;
  }

  return `+${DEFAULT_COUNTRY_CODE}${digits}`;
};
